export default __webpack_public_path__ + "4d442a0301b41186bb1e8c76569d7520.pdf";